import type { CancelTokenSource, CancelTokenStatic } from 'axios'

const requestSources: { [key: string]: CancelTokenSource } = {}

export function getCancelToken({ name, cancelToken }: { name: string; cancelToken: CancelTokenStatic }) {
  requestSources[name]?.cancel?.('was-canceled')
  requestSources[name] = cancelToken.source()
  return requestSources[name].token
}
